export default __webpack_public_path__ + "static/media/blackboard.2fb7dac6.svg";